/**
 * ============================================================
 * KEJJA OS — src/hooks/useMe.ts
 * React Query hooks for the /me/* endpoints.
 * ============================================================
 */

import { useQuery } from '@tanstack/react-query';
import { meApi } from '@/lib/api';

export function useMyHomes() {
  return useQuery({
    queryKey: ['me', 'homes'],
    queryFn: meApi.homes,
  });
}

export function useMyCommunities() {
  return useQuery({
    queryKey: ['me', 'communities'],
    queryFn: meApi.communities,
  });
}

export function useMyInvitations() {
  return useQuery({
    queryKey: ['me', 'invitations'],
    queryFn: meApi.invitations,
    refetchInterval: 60_000,  // check every minute for new invites
  });
}

